import {   
REQUEST_ACCOUNTTRANSACTIONS,
RECEIVE_ACCOUNTTRANSACTIONS_SUCCESS,
RECEIVE_ACCOUNTTRANSACTIONS_ERROR,
REQUEST_ACCOUNTTRANSACTIONS_SAVE,
RECEIVE_ACCOUNTTRANSACTIONS_SAVE_ERROR,
RECEIVE_ACCOUNTTRANSACTIONS_SAVE_SUCCESS,
REQUEST_ACCOUNTTRANSACTIONS_REMOVE,
RECEIVE_ACCOUNTTRANSACTIONS_REMOVE_SUCCESS,
RECEIVE_ACCOUNTBALANCE_SUCCESS,
REQUEST_ACCOUNTBALANCE,
REQUEST_BKTRANSACTIONS,
RECEIVE_BKTRANSACTIONS_ERROR,
RECEIVE_BKTRANSACTIONS_SUCCESS,
REQUEST_UPLOAD_FILE,
RECEIVE_UPLOAD_FILE_SUCCESS
        }  from '../actions/accountTransactions'


/*

        case RECEIVE_COMPANY_SAVE_SUCCESS: {
            let ind = state.companies.findIndex(x => x.id === action.company.id);
            if (ind < 0) 
                break;
            let newState = 
                {...state,
                    companies: [...state.companies],
                    isFetching: false}    
                newState.companies[ind] =  {
                        ...state.companies[ind], 
                        isFetching: false};                    
            return newState;

        }
        */

const DEFAULT_ACCOUNTTRANSACTIONS=   {
    isFetching: true,
    isUploading: false,
    upladingStatus: '',
    balance: {},
    transactions: [],
    transactionFiles: []
    };


    const DEFAULT_BKTRANSACTIONS=   {
        isFetching: true,
        balance: {},
        transactions: []
        };
    
    

        export function bkTransactions(state = DEFAULT_BKTRANSACTIONS, action) {
            switch (action.type) {
        
                case REQUEST_BKTRANSACTIONS: {
                    var newstate = {
                        transactions: [...state.transactions],    
                        balance: {...state.balance},         
                        isFetching: true,
                        isUploading: false,
                    };
                    return newstate;
                }
                case RECEIVE_BKTRANSACTIONS_SUCCESS: {
                    var newstate = {
                        ...state,   
                        transactions: [...action.loanAccountTransactions],
                        balance: {...state.balance},         
                        isFetching: false,
                        isUploading: false

                    }
                    return newstate;            
                }
                default: {
                    return state;
                }                
            }
        }        

export function accountTransactions(state = DEFAULT_ACCOUNTTRANSACTIONS, action) {
    switch (action.type) {

        case REQUEST_ACCOUNTTRANSACTIONS: {
            var newstate = {
                ...state,
                transactions: [...state.transactions],    
                balance: {...state.balance},         
                transactionFiles: [...state.transactionFiles],    
                isFetching: true,
            };
            return newstate;
        }
        case RECEIVE_ACCOUNTTRANSACTIONS_SUCCESS: {
            var newstate = {
                ...state,   
                transactions: [...action.loanAccountTransactions],
                balance: {...state.balance},      
                transactionFiles: [...state.transactionFiles],       
                isFetching: false,
                 }
            return newstate;            
        }

        case REQUEST_ACCOUNTBALANCE: {
            var newstate = {
                ...state,
                transactions:[...state.transactions],    
                balance: {...state.balance},         
                transactionFiles: [...state.transactionFiles],    
                isFetching: true,
            };
            return newstate;
        }
        case RECEIVE_ACCOUNTBALANCE_SUCCESS: {
            var newstate = {
                ...state,   
                transactions: [...state.transactions],
                balance: {...action.balance},     
                transactionFiles: [...state.transactionFiles],        
                isFetching: false,

                 }
            return newstate;            
        }

        case REQUEST_ACCOUNTTRANSACTIONS_SAVE: {       
            let newState = 
                {...state,
                    transactions: [...state.transactions],
                    balance: {...state.balance},  
                    transactionFiles: [...state.transactionFiles],           
                    isFetching: true}                 
            return newState;
        }


        case RECEIVE_ACCOUNTTRANSACTIONS_SAVE_SUCCESS:  {      
            let newState = 
            {...state,
            transactions: [...state.transactions, action.loanAccountTransaction],
            balance: {...state.balance},         
            transactionFiles: [...state.transactionFiles],    
            isFetching: false}   
            
            return newState;
        }     
        

        case REQUEST_ACCOUNTTRANSACTIONS_REMOVE: {

            let newState = 
            {...state, 
                isFetching: true,
                balance: {...state.balance},                 
                transactions: [...state.transactions],
                transactionFiles: [...state.transactionFiles],    
            }

            return newState;
        }

        case REQUEST_UPLOAD_FILE: {
            let newState = 
            {...state, 
                isUploading: true,
                uploadStatus: 'Lähetetään tiedostoa....',
                balance: {...state.balance},                 
                transactions: [...state.transactions],
                transactionFiles: [...state.transactionFiles],    
            }
            return newState;
        }
        case RECEIVE_UPLOAD_FILE_SUCCESS: {
            let newState = 
            {...state, 
                isUploading: false,
                uploadStatus: 'Tiedosto lähetetty',
                balance: {...state.balance},                 
                transactions: [...state.transactions],
                transactionFiles: [...state.transactionFiles],    
            }
            return newState;
        }


        case RECEIVE_ACCOUNTTRANSACTIONS_REMOVE_SUCCESS: {

            let ind = state.transactions.findIndex(x => x.id === action.id.id);
            if (ind < 0) 
                return {};

            var newState = 

            {...state,
                isFetching: false,
                balance: {...state.balance},         
                transactionFiles: [...state.transactionFiles],    
                transactions: [...state.transactions.slice(0, ind),
                    ...state.transactions.slice(ind + 1)]}

            return newState;
        }

        default: {
            return state;
        }
    }
}
